import { Card } from '@zorro/design-system/v2/Card';
import {
  Stepper,
  type StepperStepProps,
} from '@zorro/design-system/v2/Stepper';
import { Title } from '@zorro/design-system/v2/Title';
import { Group } from '@zorro/web/design-system';

import {
  BulkApplicationStepType,
  getBulkApplicationStepConfig,
} from './BulkApplicationUtils';

type StepperLinkProps = StepperStepProps & {
  bulkApplicationStep: BulkApplicationStepType;
};

const StepperLink = ({ bulkApplicationStep, ...props }: StepperLinkProps) => {
  const { label } = getBulkApplicationStepConfig(bulkApplicationStep);

  return <Stepper.Step {...props} label={label} />;
};

type Props = {
  step: BulkApplicationStepType;
};

export const BulkApplicationStepper = ({ step }: Props) => {
  const { stepIndex } = getBulkApplicationStepConfig(step);

  return (
    <Card variant="grey" style={{ borderRadius: 8 }}>
      <Group justify="space-between" align="center" mb="md">
        <Title>Bulk application</Title>
      </Group>
      <Stepper
        allowNextStepsSelect={false}
        active={stepIndex}
        wrap={false}
        size="sm"
        mt="lg"
      >
        {Object.values(BulkApplicationStepType).map((bulkApplicationStep) => (
          <StepperLink
            key={bulkApplicationStep}
            bulkApplicationStep={bulkApplicationStep}
          />
        ))}
      </Stepper>
    </Card>
  );
};
